import gql from "graphql-tag"

/** Fragments */
export const BUSINESS_SETTINGS_FIELDS = gql`
  fragment BusinessSettingsFields on TenantTypeOutput {
    ged
    gedReferentialOnly
    gedMainFolderSampleId
    logo
    useAI
    useSSO
    homePage
    referentialUserId
    languageId
    controlsGracePeriod {
      assignation
      daysValue
    }
    summaryRemindersRules {
      id
      offsetDays
    }
    tasksDelayRules {
      afterDue
      beforeDue
      beforeStart
      afterStart
    }
    workflowStepReminder {
      enabled
      days
      recurring
      workflowIds
    }
    enableSentryFeedback
    enableScreening
    showAddSampleButtonLabel
    showDirectoriesScroller
    primaryColor
    secondaryColor
    bannerColor
    separatorColor
    aiColor
    headerAccentColor
    alternativeActionColor
    illustrationColor
    sideMenuColor
    headerColor
    sideMenu {
      sideMenuColor
      sideMenuGradientOne
      useGradientSideMenu
    }
    formStyle {
      radius
      density
      fieldBg
      readBoxed
      textMaxHeight
      tableRows
      groupBg
      groupRadius
      groupShadow
    }
    dateFormats {
      language
      pattern
    }
    appName
    searchPageSubtitle
    emailSenderName
    emailReplyTo
    palettes {
      paletteId
      isDefault
      colors
      name
    }
    faq {
      enableFaq
      enableFaqFeedback
    }
    buttons_pinned {
      id
      buttons
      view
    }
  }
`

/**
 * Défauts de préférences posés par l'admin. Séparé de `BusinessSettingsFields` : la grille et
 * l'écran de réglages en ont besoin, la page Branding non — la tirer partout coûterait des champs
 * pour rien.
 */
export const BUSINESS_USER_DEFAULTS_FIELDS = gql`
  fragment BusinessUserDefaultsFields on TenantTypeOutput {
    userDefaults {
      values {
        showFilterBar
        sendToEmail
        notifyOwnChanges
        sendSummary
        summaryFrequency
      }
      locked
      firstLoginPrompt {
        enabled
        keys
      }
      lastApply {
        at
        byUserId
        keys
        applied
        skipped
        failed
      }
    }
  }
`

export const GET_BUSINESS_USER_DEFAULTS = gql`
  query GetBusinessUserDefaults {
    getBusinessSettings {
      ...BusinessUserDefaultsFields
    }
  }
  ${BUSINESS_USER_DEFAULTS_FIELDS}
`

export const BUSINESS_TABLE_STYLE_FIELDS = gql`
  fragment BusinessTableStyleFields on TenantTypeOutput {
    tableStyle {
      headerStyle
      density
      zebra
      rowGap
      card
      showColumnSeparators
      hideRowSeparators
      rowHover
      linkTableFilterRowDefault
    }
  }
`

/** Queries */
export const GET_BUSINESS_SETTINGS = gql`
  query GetBusinessSettings {
    getBusinessSettings {
      ...BusinessSettingsFields
    }
  }
  ${BUSINESS_SETTINGS_FIELDS}
`

export const GET_BUSINESS_SAMPLE_SETTINGS = gql`
  query GetBusinessSampleSettings {
    getBusinessSettings {
      showAddSampleButtonLabel
    }
  }
`

export const GET_BUSINESS_TABLE_SETTINGS = gql`
  query GetBusinessTableSettings {
    getBusinessSettings {
      ...BusinessTableStyleFields
    }
  }
  ${BUSINESS_TABLE_STYLE_FIELDS}
`
